// extracted by mini-css-extract-plugin
export default {"page404":"Page404_page404__cEyyr","error404":"Page404_error404__EwjSH"};